import type { FaireProductEntity } from "../../entity_types/product";

export const p_f4aq3vht2f: FaireProductEntity = {
  token: "p_f4aq3vht2f",
  type: "product",
  name: "Old Fart Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/da64286ffa3ac4c20293e5b28bf0a0f9879b82a337d09b322790e53fb0e924e8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5f027372dba785b2c1f00317756b7f9421ae182ea67f4b79f44c6fb4c322d5c4.jpeg",
    "https://cdn.faire.com/fastly/aeb906a6c048b70f6ace4329430e15e9a3ca83c4937dfeff7e067c9f55355984.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/51a53b16f254951c5c1d582a3fa42c1498a37c5a45dd26d16f71c59c2bf55596.jpeg",
    "https://cdn.faire.com/fastly/019b211ec2d9abe57b5465a53c0d394661c9cea0e9752fbd857c3ce3b945af23.jpeg"
  ],
  priceDollars: 6.75,
  description: "You don’t have to be of advanced age to be an OLD FART. All you need is some Werther's Original, a small arsenal of dad noises, and a pair of these extra comfy socks!\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:27:57.604Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
